import { Component, OnInit, ChangeDetectorRef, HostListener, ViewChild } from '@angular/core';
import { AuthService } from '../core/services/auth/auth.service';
import { Router } from '@angular/router';
import { PaginationCriteria } from 'jul-web-shared-lib';
import { environment } from 'src/environments/environment';
import { TimerObservable } from 'rxjs/observable/TimerObservable';
import { Subscription } from 'rxjs';
import { PerfectScrollbarComponent } from 'ngx-perfect-scrollbar';
import { AlertifyService } from 'jul-web-shared-lib/src/lib/components/alertify';
import { v4 as uuid } from "uuid";
import { Store, select } from '@ngrx/store';
import * as fromCoreStore from "../core/_store";
import { DeputyActions, AdministratorModeActions } from '../core/_store';
import { filter, map } from 'rxjs/operators';
import { Base64Utils } from '../core/utils/Base64Utils';
import { TabsComponent } from '../tabs/tabs.component';
import { TabService } from '../tabs/services/tab.service';
import { MessageService } from '../services/message.service';
import { Actions } from '@ngrx/effects';
import { DeputyActionTypes } from '../core/_store/actions/deputy.actions';
import { Task } from '../core/models/notifications/task.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  title = 'jul-web-core-new';
  notificationsData: Array<Notification> = new Array<Notification>();
  tasksData: Array<Task> = new Array<Task>();
  timerNotification: TimerObservable<any>;
  storeSubscription$: Subscription;
  notificationsLoaded = false;
  loading = false;
  error = false;
  domain: any;
  alertId: string = uuid();
  production: boolean = true;
  criteria = new PaginationCriteria<Notification>(6, [], {}, 6, 1);
  mediaSize: any;
  alerts: Array<{}>;
  environmentLabel: string;
  substitutes: any;
  isSubstitution: boolean = false;
  isImpersonalization: boolean = false;
  possibleImpersonalizationsSubscription$: Subscription = new Subscription();
  possibleImpersonalizations: any;
  isAdminSubscription$: Subscription;
  storePhotosSubscription$: Subscription;
  _isLoading: boolean = false;
  isPublic: boolean = false;
  firstLoad: boolean = true;
  isAdmin: boolean = false;
  isSuperUser: boolean = false;
  @ViewChild('ps') perfectScrollbar: PerfectScrollbarComponent;
  @ViewChild('tabs') tabs: TabsComponent;
  oldToken: any;
  oldUser: any;
  currentUser:any;
  user: any;
  applicableHomepage = '/dashboard/page/vessel';

  constructor(
    public authService: AuthService,
    private alertify: AlertifyService,
    private messageService: MessageService,
    private actions: Actions,
    private store: Store<fromCoreStore.CoreState>,
    private cdr: ChangeDetectorRef,
    private route: Router,
    private tabService: TabService,
    ) {
      route.events.subscribe(val => {
        if(!this.authService.loggedIn()){
          this.isPublic = true
        } else {
          this.isPublic = false
        }
        console.log(val)
      });

    }
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (event && event.target) {
      this.mediaSize = window.matchMedia("(max-width: 768px)").matches ? 1 : (window.matchMedia("(max-width: 1200px)").matches ? 2 : 3);
      if (this.mediaSize == 1) {
        setTimeout(() => {
          document.querySelector('.environment_mode_small').setAttribute('domain', this.environmentLabel);
        })
      } else if (this.mediaSize == 2) {
        setTimeout(() => {
          document.querySelector('.environment_mode_regular').setAttribute('domain', this.environmentLabel);
        })
      } else {
        setTimeout(() => {
          document.querySelector('.environment_mode_big').setAttribute('domain', this.environmentLabel);
        })
      }
    }
  }

  logout() {
    if (!!localStorage['driverLoginModel']) {
      // gas-cup login
      localStorage.clear();
      this.route.navigate(['gas','cup-login']);
      return;
    }

    const cloneTabs = this.tabs.navLinks;
    if (cloneTabs && Array.isArray(cloneTabs)) {
      cloneTabs.forEach((x: any) => {
        this.tabService.removeTab(0);
      });
    }

    this.authService.logout().subscribe(x => {
      this.route.navigate(['authentication','login']);
    });
  }

  editUserRedirect() {
    let baseRef = environment.server;
    if (!baseRef.endsWith("/")) {
      baseRef += "/";
    }

    let external = "web/#";

    window.location.href = baseRef + external + '/gad/config/user-personal-management';
  }

  getSubstitutes() {
    if (!this.substitutes && !this.isSubstitution) {
      this.isLoading = true;
      this.store.dispatch(new DeputyActions.LoadPossibleDeputies());
    }
  }

  setSuperUser(): boolean {
    const user: any = JSON.parse(localStorage.getItem("user"));
    if (user && user.superUser) {
      return true;
    } else {
      return false;
    }
  }

  ngOnInit() {

    this.user = JSON.parse(localStorage.getItem('user'));

    if (this.user && this.user.applicableHomepage && this.user.applicableHomepage.url){
      this.applicableHomepage = this.user.applicableHomepage.url;
    }

    this.oldToken = localStorage.getItem('oldToken');
    this.oldUser = JSON.parse(localStorage.getItem('oldUser'));
    this.currentUser = JSON.parse(localStorage.getItem('user'));

    this.isSuperUser = this.setSuperUser();
    if (environment && environment.environmentLabel && environment.environmentLabel != '') {
      this.production = false;
      this.environmentLabel = environment.environmentLabel;
    } else {
      this.production = true;
    }
    this.mediaSize = window.matchMedia("(max-width: 768px)").matches ? 1 : (window.matchMedia("(max-width: 1200px)").matches ? 2 : 3);
    if (this.mediaSize == 1) {
      setTimeout(() => {
        document.querySelector('.environment_mode_small').setAttribute('domain', this.environmentLabel);
      })
    } else if (this.mediaSize == 2) {
      setTimeout(() => {
        document.querySelector('.environment_mode_regular').setAttribute('domain', this.environmentLabel);
      })
    } else {
      setTimeout(() => {
        document.querySelector('.environment_mode_big').setAttribute('domain', this.environmentLabel);
      })
    }
    this.isAdminSubscription$ = this.store.pipe(
      select(fromCoreStore.getSelectedIsAdmin)
    )
      .subscribe(data => {
        if (data != undefined) {
          this.isAdmin = data;
        } else {
          this.isAdmin = localStorage.getItem("isAdmin") ? true : false;
        }
      });

      this.possibleImpersonalizationsSubscription$.add(
        this.actions.pipe(
          filter((action:any) => Object.is(DeputyActionTypes.LOAD_POSSIBLE_DEPUTIES_SUCCESS,action.type)),
          map((action:DeputyActions.LoadPossibleDeputiesSuccess) => action.payload))
          .subscribe((data:any) => {
            if (data && data.length > 0) {
              this.substitutes = data;
              setTimeout(() => {
                this.cdr.detectChanges();
              });
            } else {
              this.isLoading = false;
            }          
          })
        );
      this.possibleImpersonalizationsSubscription$.add(
        this.actions.pipe(
          filter((action:any) => Object.is(DeputyActionTypes.LOAD_SUBSTITUTES_PHOTOS_SUCCESS,action.type)),
          map((action:DeputyActions.LoadPossibleDeputiesSuccess) => action.payload))
          .subscribe((data:any) => {
            if (data) {
              this.isLoading = false;
              setTimeout(() => {
                this.cdr.detectChanges();
              });
            }        
          })
        );

      this.possibleImpersonalizationsSubscription$.add(
        this.actions.pipe(
          filter((action: any) => Object.is(DeputyActionTypes.LOAD_IMPERSONALIZATION_LIST_SUCCESS, action.type)),
          map((action: DeputyActions.LoadImpersonalizationListSuccess) => action.payload))
        .subscribe((data: any) => {
          if (this.firstLoad && data) {
            this.messageService.impersonalizationPopup(data);
            this.firstLoad = false;
          }
        })
      );


      this.possibleImpersonalizationsSubscription$.add(
        this.actions.pipe(
          filter((action: any) => Object.is(DeputyActionTypes.IMPERSONALIZE_USER_SUCCESS, action.type)),
          map((action: DeputyActions.ImpersonalizeUserSuccess) => action.payload))
        .subscribe((user: any) => {
          if (user && user.token) {
            this.changeUser(user);
            if (user && user.applicableHomepage && user.applicableHomepage.url){
              this.applicableHomepage = user.applicableHomepage.url;
            }
            this.isImpersonalization = true;
            setTimeout(()=>{
              window.location.href = this.redirectToHomepage;
              location.reload();
            },2000);
  
            this.alertify.success("generic.impersonalization.success", true);
            this.cdr.markForCheck();
          }
        })
      );

      this.possibleImpersonalizationsSubscription$.add(
        this.actions.pipe(
          filter((action: any) => Object.is(DeputyActionTypes.LOAD_SUBSTITUTE_SUCCESS, action.type)),
          map((action: DeputyActions.LoadSubstituteSuccess) => action.payload))
        .subscribe((user: any) => {
          if (user && user.token) {
            this.changeUser(user);
            if (user && user.applicableHomepage && user.applicableHomepage.url){
              this.applicableHomepage = user.applicableHomepage.url;
            }
            this.isSubstitution = true;
            setTimeout(()=>{
              window.location.href = this.redirectToHomepage;
              location.reload();
            }, 2000);
            this.alertify.success("generic.substitution.success", true);
            this.cdr.markForCheck();
          }
        })
      );

    this.authService.decodedToken = this.authService.jwtHelper.decodeToken(localStorage.getItem('token'));
    if (this.authService && this.authService.decodedToken && this.authService.decodedToken.hasOwnProperty('impersonate')) {
      this.isImpersonalization = true;
    } else if (this.authService && this.authService.decodedToken && this.authService.decodedToken.hasOwnProperty('deputy')) {
      this.isSubstitution = true;
    }
  }
  ngOnChanges(): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.

  }
  /**
   * The session (token/user) lives in localStorage, which is shared by every
   * tab of the same origin. When another tab changes it (impersonation,
   * substitution, return to origin or logout), this tab must reload so its
   * interface never keeps acting as a stale user.
   */
  @HostListener('window:storage', ['$event'])
  onSessionStorageChange(event: StorageEvent) {
    if (event.key === 'token' && event.oldValue !== event.newValue) {
      location.reload();
    }
  }

  changeUser(user: any) {
    indexedDB.deleteDatabase('NGRX Storage');
    // Keep the original user when already impersonating/substituting:
    // otherwise a chained impersonation overwrites the real origin and
    // "return to origin user" would restore the wrong user
    if (!localStorage.getItem('oldToken')) {
      localStorage.setItem('oldToken', localStorage.getItem('token'));
      localStorage.setItem('oldUser', localStorage.getItem('user'));
    }
    localStorage.setItem('token', user.token);
    let photo: any = null;
    if (user.photo) {
      let mime = Base64Utils.getImgMimeType(user.photo);
      photo = {
        base64: user.photo,
        preview: "data:" + mime + ";base64," + user.photo
      }
    }
    this.authService.decodedToken = this.authService.jwtHelper.decodeToken(user.token);
    this.authService.currentUser = { ...user, photo: photo };
    this.authService.userToken = user.user;
    localStorage.setItem('user', JSON.stringify({ ...user, photo: photo }));
    // Login alerts belong to the previous user; force a fresh fetch after reload.
    localStorage.removeItem('login-alerts');
    this.alertify.alertId = undefined;
  }

  changeToOldUser(){
    localStorage.setItem('user', localStorage.getItem('oldUser'));
    localStorage.setItem('token', localStorage.getItem('oldToken'));

    this.authService.decodedToken = this.authService.jwtHelper.decodeToken(this.oldUser.token);
    let photo: any = null;
    if (this.oldUser.photo) {
      let mime = Base64Utils.getImgMimeType(this.oldUser.photo.base64);
      photo = {
        base64: this.oldUser.photo,
        preview: "data:" + mime + ";base64," + this.oldUser.photo
      }
    }
    this.authService.currentUser = { ...this.oldUser, photo: photo };
    this.authService.userToken = this.oldUser.user;

    localStorage.removeItem('oldToken');
    localStorage.removeItem('oldUser');
    // Login alerts belong to the impersonated user; force a fresh fetch after reload.
    localStorage.removeItem('login-alerts');

    this.alertify.alertId = undefined;
    setTimeout(()=>{
      location.reload();
    }, 2000);
    this.alertify.success("generic.backToOriginUser.success", true);
    this.cdr.markForCheck();
  }

  loadPossibleImpersonalizations() {
    this.firstLoad = true;
    let criteria: PaginationCriteria<any> = new PaginationCriteria<any>(25, [], {enabled:true} as any, 25, 1);
    this.store.dispatch(
      new DeputyActions.LoadImpersonalizationList(criteria)
    );
  }

  get isLoading() {
    return this._isLoading;
  }

  set isLoading(isLoading: boolean) {
    this._isLoading = isLoading;
  }

  loadSubstitute(index: number) {
    this.store.dispatch(new DeputyActions.LoadSubstitute(this.substitutes[index].username));
  }

  loadMenuAdmin() {
    this.store.dispatch(new AdministratorModeActions.LoadMenuAdmin());
  }

  loadMenuRegular() {
    this.store.dispatch(new AdministratorModeActions.LoadMenuRegular());
  }

  ngOnDestroy() {
    if(this.possibleImpersonalizationsSubscription$){
      this.possibleImpersonalizationsSubscription$.unsubscribe();
    }
    if(this.storeSubscription$){
      this.storeSubscription$.unsubscribe();
    }
    if(this.storePhotosSubscription$){
      this.storePhotosSubscription$.unsubscribe();
    }
    if(this.isAdminSubscription$){
      this.isAdminSubscription$.unsubscribe();
    }
  }

  get redirectToHomepage(){
    let baseRef = environment.server;
    if (!baseRef.endsWith("/")) {
      baseRef += "/";
    }

    let path = '/dashboard/page/vessel';
    let external = "web/#";

    if (this.applicableHomepage && this.applicableHomepage!='/home'){

      path = this.applicableHomepage;

      if (!path.startsWith("/")) {
        path += "/";
      }

    }

    return baseRef + external + path;

  }

}
